var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bar-chart',{attrs:{"data":_vm.data,"dataset":{borderWidth: 0},"legend":_vm.legend}})}
var staticRenderFns = []

export { render, staticRenderFns }